import { render, staticRenderFns } from "./broadcast-clicks.vue?vue&type=template&id=7a8e98b2"
import script from "./broadcast-clicks.vue?vue&type=script&lang=js"
export * from "./broadcast-clicks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports